import { forwardRef } from "react";
import Card from "src/components/UI/Card/Card";
import { useAutoFocus } from "src/hooks/useAutoFocus";

const SidePanel = forwardRef(function SidePanel({ opts, isClosing, children }, ref) {
  const portalRef = useAutoFocus(!isClosing, { externalRef: ref });

  return (
    <Card
      ref={portalRef}
      className={"sidebar " + (isClosing ? "close" : "open")}
      opts={{ ...opts }}
      shadowLg>
      {children}
    </Card>
  );
});
export default SidePanel;
